import { SortableTable } from '../../molecules';
import { Action, Icon, Label, TableRow } from '../../atoms';
import { Button, Container } from 'react-bootstrap';
import styles from './OrganizationsTemplate.module.css';
import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import Spinner from '../../atoms/Spinner/Spinner';
import { useNavigate } from 'react-router-dom';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';

export interface OrganizationsTemplateProps {
  data: BuyerResponseDto[];
  handleDeleteOrganization: (id: string) => void;
}

const OrganizationsTemplate: FC<OrganizationsTemplateProps> = ({
  data,
  handleDeleteOrganization,
}) => {
  const navigate = useNavigate();

  const handleDelete = (id: string) => {
    handleDeleteOrganization(id);
  };

  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label content="Organizations" bold size="lg" />
          <Button href="/organizations/add" variant="dark">
            Add Organization
          </Button>
        </div>
        {data.length !== 0 ? (
          <SortableTable
            data={data}
            columns={[
              { label: 'Logo', key: 'logo' },
              { label: 'Name', key: 'name' },
              { label: 'Url', key: 'url' },
              { label: 'Profile Type', key: 'profileType' },
              { label: 'Description', key: 'description' },
            ]}
            renderRow={(row) => (
              <TableRow key={row.id}>
                <Icon imageUrl={row.logo ?? ''} shape="thumbnail" size="xs" />
                <Label content={row.name ?? ''}></Label>
                <Label content={row.url ?? ''}></Label>
                <Label content={row.profileType ?? ''}></Label>
                <Label content={row.description ?? ''}></Label>
                <Action
                  type="edit"
                  size="sm"
                  onClick={() => navigate(`/organizations/edit/${row.id}`)}
                ></Action>
                <Action
                  type="delete"
                  itemName={row.name ?? undefined}
                  size="sm"
                  onClick={() => handleDelete(row.id)}
                ></Action>
              </TableRow>
            )}
          />
        ) : (
          <Spinner />
        )}
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationsTemplate;
